import numberToString from '@anm/helpers/string/numberToString';

const getStringDate = (dateObj: Date) => {
  const year = dateObj.getFullYear();
  const month = numberToString(dateObj.getMonth() + 1);
  const date = numberToString(dateObj.getDate());

  return `${year}-${month}-${date}`;
};

export default getStringDate;
